export default "__VITE_ASSET__DLGHyYh5__"